﻿/**
 * Generates an un-ambiguous randomised 7-character password
 * composed of mixed uppercase letters and numbers.
 * Excludes characters that look like each other:
 * - '0' and 'O'
 * - '1', 'I', and 'L'
 */
export function generateVoterPassword(length = 7): string {
  const digits = '23456789'; // excludes 0, 1
  const letters = 'ABCDEFGHJKMNPQRSTUVWXYZ'; // excludes I, O, L
  const all = digits + letters;

  // Guarantee at least two digits and two letters for mixed complexity
  const pwd: string[] = [
    digits[Math.floor(Math.random() * digits.length)],
    letters[Math.floor(Math.random() * letters.length)],
    digits[Math.floor(Math.random() * digits.length)],
    letters[Math.floor(Math.random() * letters.length)],
  ];

  for (let i = 4; i < length; i++) {
    pwd.push(all[Math.floor(Math.random() * all.length)]);
  }

  // Shuffle characters
  return pwd.sort(() => Math.random() - 0.5).join('');
}
